import * as React from 'react';
// import { SmTwitterIcon } from 'naan/icons/sm-twitter-icon';
// import { SmInstagramIcon } from 'naan/icons/sm-instagram-icon';
import { PowByJw } from './logos/pow-by-jw';
import { RaLogo } from './logos/ra';
import { styled } from 'naan/stitches.config';
import { HSpacer } from 'naan/primitives/spacer';
//@ts-expect-error
import { version } from '@jw-spa-version';
import { ExternalLink } from '@naan/primitives/text/external-link';

const Wrapper = styled('footer', {
  // position: 'sticky',
  // bottom: 0,
  display: 'grid',
  gridTemplateColumns: 'repeat(4,1fr)',
  gridTemplateRows: 'repeat(2,auto)',
  color: '$textSecondary',
  a: {
    color: 'inherit',
    textDecoration: 'none',
  },
  '& .logos': {
    // background: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gridColumn: '1/-1',
    gridRow: '1/2',
    borderBottom: '1px solid $colors$gray-100',
    py: '$space$5',
  },
  '& .links': {
    // background: 'yellow',
    alignItems: 'center',
    display: 'flex',
    gridColumn: '1/3',
    gridRow: '2/3',
    py: '$space$5',
    textStyle: 'tiny-text',
    a: {
      flexShrink: 0,
      paddingRight: '6px',
      marginRight: '6px',
      borderRight: '1px solid $colors$gray-100',
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
  '& .support-links': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    gridColumn: '3/5',
    gridRow: '2/3',
    py: '$space$5',
    textStyle: 'tiny-text',
    a: {
      flexShrink: 0,
      paddingRight: '6px',
      marginRight: '6px',
      borderRight: '1px solid $colors$gray-100',
      '&:last-child': {
        paddingRight: '0',
        marginRight: '0',
        borderRight: 'none',
      },
    },
    span: {
      color: '$colors$gray-200',
    },
  },
  '& .socials': {
    // background: 'orange',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gridColumn: '3/5',
    gridRow: '2/3',
    py: '$space$5',
    a: {
      marginLeft: '$space$3',
    },
  },
  '@small': {
    '& .links': {
      textStyle: 'small-text',
      a: {
        paddingRight: '$space$2',
        marginRight: '$space$2',
      },
    },
    '& .support-links': {
      textStyle: 'small-text',
      a: {
        paddingRight: '$space$2',
        marginRight: '$space$2',
      },
    },
  },
  '@extraLarge': {
    gridTemplateColumns: 'repeat(3,1fr)',
    gridTemplateRows: '1',
    borderTop: '1px solid $colors$gray-100',

    '& .logos': {
      gridColumn: '2/3',
      border: 'none',
    },
    '& .links': {
      gridColumn: '1/2',
      gridRow: '1',
    },
    '& .support-links': {
      gridColumn: '3/4',
      gridRow: '1',
    },
    '& .socials': {
      gridColumn: '3/4',
      gridRow: '1',
    },
    margin: '0 auto',
    width: '960px', //maybe this should be a var somewhere
  },
});

export const GlobalFooter = () => {
  return (
    <>
      <Wrapper>
        <div className="logos">
          <ExternalLink href="https://radioambulante.org/">
            <RaLogo />
          </ExternalLink>
          <HSpacer size={6} />
          <ExternalLink href="https://www.jiveworld.com/">
            <PowByJw />
          </ExternalLink>
        </div>

        <div className="links">
          <ExternalLink href="https://www.jiveworld.com/terms-of-service">
            Terms of service
          </ExternalLink>
          <ExternalLink href="https://www.jiveworld.com/privacy">
            Privacy
          </ExternalLink>
          <ExternalLink href="https://www.jiveworld.com/eula">
            EULA
          </ExternalLink>
        </div>
        <div className="support-links">
          <ExternalLink href="https://www.lupa.app/contact-us">
            Contact &amp; support
          </ExternalLink>
          <span title={version}>v{version}</span>
          {/* {appConfig<>('soundbites.globalFooterLink') ? (
            <span>
              | <a href="/try-soundbites">sb</a>
            </span>
          ) : null} */}
        </div>
        {/* <div className="socials">
        <ExternalLink href="https://twitter.com/LupaApp" >
          <SmTwitterIcon />
        </ExternalLink>
        <ExternalLink
          href="https://www.instagram.com/lupa.app/"
        >
          <SmInstagramIcon />
        </ExternalLink>
      </div> */}
      </Wrapper>
    </>
  );
};
